<template>
	<div class="max-w-7xl px-6 md:px-0 mx-auto z-30 relative">
		<div class="text-center">
			<h1 class="mt-12 font-gilroy-extrabold text-black relative z-30 text-5xl"> Explore our projects</h1>
			<div class="mt-12 max-w-sm md:max-w-max mx-auto grid grid-cols-2 gap-4 md:gap-0 md:flex md:flex-row ">
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'all'"
						:class="isActive == 'all' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>All projects</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'ecommerce'"
						:class="isActive == 'ecommerce' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>E-Commerce</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'marketplaces'"
						:class="isActive == 'marketplaces' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Marketplaces</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'education'"
						:class="isActive == 'education' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 hover:scale-105 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Education</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'sports'"
						:class="isActive == 'sports' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Sports</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'agriculture'"
						:class="isActive == 'agriculture' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Agriculture</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'estate'"
						:class="isActive == 'estate' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Real estate</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'horeca'"
						:class="isActive == 'horeca' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>HoReCa</span>
				</div>
				<div class="w-full md:max-w-max flex-initial md:mr-4">
					<span
						@click="isActive = 'health'"
						:class="isActive == 'health' ? ['bg-purple-500', 'text-white'] : ['bg-white', 'text-purple-500']"
						class="block w-full border border-purple-500 transition transform hover:bg-purple-500 duration-500 hover:text-white text-inter-500 text-sm cursor-pointer px-5 py-3 rounded-full"
					>Health</span>
				</div>
			</div>

			<div class="mt-16">
				<div class="grid grid-cols-1 md:grid-cols-3 gap-4">

					<Project 
						:isActive="isActive" 
						projectPhoto="schoolflix.png" 
						projectCategory="education" 
						projectLink="https://schoolflix.ro/" 
						projectName="Schoolflix"
						projectColorFrom="blue-500" 
						projectColorTo="purple-600"
						:developers="['cds', 'ar', 't2']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="sakura.png" 
						projectCategory="education" 
						projectLink="https://sakura.school/" 
						projectName="Sakura"
						projectColorFrom="pink-500" 
						projectColorTo="red-500"
						:developers="['cds', 'ar']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="mecenaart.png" 
						projectCategory="education" 
						projectLink="https://mecena.app/" 
						projectName="Scoala de Muzica"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds', 'ar']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="osdubb.png" 
						projectCategory="education" 
						projectLink="https://osdubb.ro/" 
						projectName="OSDUBB"
						projectColorFrom="pink-500" 
						projectColorTo="yellow-500"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="vinarte.png" 
						projectCategory="ecommerce" 
						projectLink="https://vinarte.ro/" 
						projectName="Vinarte"
						projectColorFrom="indigo-300" 
						projectColorTo="purple-400"
						:developers="['cds', 'ar', 't2']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="3ptvin.png" 
						projectCategory="ecommerce" 
						projectLink="https://treipentruvin.ro/" 
						projectName="TreiPentruVin"
						projectColorFrom="pink-300" 
						projectColorTo="indigo-400"
						:developers="['cds', 'ar', 't2']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="zenhotel.png" 
						projectCategory="sports" 
						projectLink="https://vrancea-trophy.ro/" 
						projectName="Vrancea Trophy"
						projectColorFrom="green-300" 
						projectColorTo="green-400"
						:developers="['cds']"
					/>

					
					<Project 
						:isActive="isActive" 
						projectPhoto="vinarte.png" 
						projectCategory="sports" 
						projectLink="https://vinarte.ro/" 
						projectName="WTA Bucharest Open"
						projectColorFrom="yellow-600" 
						projectColorTo="red-600"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="farmeria.png" 
						projectCategory="agriculture" 
						projectLink="https://farmeria.ro/" 
						projectName="Farmeria"
						projectColorFrom="green-300" 
						projectColorTo="green-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="ialoc.png" 
						projectCategory="ecommerce" 
						projectLink="https://ialoc.ro/" 
						projectName="IaLoc.ro"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds', 't2', 'ar']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="mecenaart.png" 
						projectCategory="ecommerce" 
						projectLink="https://mecena.app/" 
						projectName="Mecena Art"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds', 't2', 'ar']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="autotis.png" 
						projectCategory="ecommerce" 
						projectLink="https://autotis.ro/" 
						projectName="AutoTIS"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="noss.png" 
						projectCategory="ecommerce" 
						projectLink="https://noss.ro/" 
						projectName="NOSS.ro"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="zazzonline.png" 
						projectCategory="marketplaces" 
						projectLink="https://zazzonline.ro/" 
						projectName="ZazzOnline" 
						projectColorFrom="green-300" 
						projectColorTo="green-400"
						:developers="['cds', 't2']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="zazzonline.png" 
						projectCategory="marketplaces" 
						projectLink="https://smart-club.ro/" 
						projectName="SmartClub" 
						projectColorFrom="yellow-300" 
						projectColorTo="yellow-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="vangardio.png" 
						projectCategory="estate" 
						projectLink="https://vangardio.com/" 
						projectName="Vangardio"
						projectColorFrom="green-300" 
						projectColorTo="green-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="javu.png" 
						projectCategory="horeca" 
						projectLink="https://vangardio.com/" 
						projectName="JAVU"
						projectColorFrom="blue-500" 
						projectColorTo="purple-600"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="zenhotel.png" 
						projectCategory="horeca" 
						projectLink="https://zenhotelfocsani.ro/" 
						projectName="Zen Hotel"
						projectColorFrom="green-300" 
						projectColorTo="green-400"
						:developers="['cds']"
					/>

					<Project 
						:isActive="isActive" 
						projectPhoto="zenhotel.png" 
						projectCategory="health" 
						projectLink="https://zenhotelfocsani.ro/" 
						projectName="HealthLog"
						projectColorFrom="red-300" 
						projectColorTo="red-400"
						:developers="['cds']"
					/>
				</div>
			</div>
		</div>

		<Contact />

	</div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
	opacity: 0;
}
</style>

<script>

import Project from '@/components/Project'
import Contact from '@/components/Contact'

export default {
	components: {
		Project,
		Contact
	},
	data() {
		return {
			isActive: 'all'
		}
	}
}
</script>